import { render, staticRenderFns } from "./ReservedAndEnabledTable.vue?vue&type=template&id=00541196"
import script from "./ReservedAndEnabledTable.vue?vue&type=script&lang=js"
export * from "./ReservedAndEnabledTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports